import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';

const UnitPriceScoreChart = (props) => {
    const { unitPriceData } = props
    const [priceScorechartData, setPriceScoreChartData] = useState({});
    const [priceScorechartOptions, setPriceScoreChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');


        const relQuotUnitPriceScore = unitPriceData?.map(item => item?.quotUnitPriceScore)
        const relNegotiationScore = unitPriceData?.map(item => item?.negotiationScore)
        const relPOUnitPriceScore = unitPriceData?.map(item => item?.POUnitPriceScore)
        const data = {
            labels: ['present vendor(company)', 'competitive vendor1', 'competitive vendor2', 'competitive vendor3', 'competitive vendor4', 'competitive vendor5'],
            datasets: [
                {
                    label: 'QuotUnitPriceScore',
                    type: "bar",
                    data: relQuotUnitPriceScore,
                    
                    backgroundColor: documentStyle.getPropertyValue('--pink-300'),
                    borderColor: 'white',
                    borderWidth: 2
                    
                },
                {
                    label: 'POUnitPriceScore',
                    type: "bar",
                    data: relPOUnitPriceScore,
                   
                    backgroundColor: documentStyle.getPropertyValue('--green-300'),
                    borderColor: 'white',
                    borderWidth: 2
                    
                },
                {
                    label: 'NegotiationScore',
                    type: "bar",
                    data: relNegotiationScore,
                   
                    backgroundColor: documentStyle.getPropertyValue('--blue-300'),
                    borderColor: 'white',
                    borderWidth: 2
                    
                },
                
                
            ]
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };

        setPriceScoreChartData(data);
        setPriceScoreChartOptions(options);
    }, [unitPriceData]);

    return (
        <div className="card">
            <Chart type="line" data={priceScorechartData} options={priceScorechartOptions} style={{ height: "300px", width: ""}} />
        </div>
    )
}
export default UnitPriceScoreChart;
        